<template>
  <div class="formSwitch">
    <slot />
    <input
      :id="name"
      :name="name"
      :checked="value"
      type="checkbox"
      class="formSwitch__input"
      :disabled="disabled"
      @change="$emit('input', $event)"
    />
    <label :for="name" class="formSwitch__label" />
  </div>
</template>

<script>
export default {
  name: 'FormSwitch',
  props: {
    name: {
      type: String,
      required: true,
    },
    value: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss">
.formSwitch {
  $root: &;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: fit-content;

  #{$root}__input:checked + #{$root}__label {
    background: $cMain;

    &:after {
      transform: translateX(1.6rem);
    }
  }

  #{$root}__input:disabled + #{$root}__label {
    opacity: 0.5;
  }

  &__input {
    height: 0;
    width: 0;
    visibility: hidden;
  }

  &__label {
    cursor: pointer;
    width: 3.6rem;
    min-width: 3.6rem;
    height: 2rem;
    background: $cAddNeutral;
    display: block;
    border-radius: 10px;
    position: relative;

    &:after {
      content: '';
      position: absolute;
      top: 0.2rem;
      left: 0.2rem;
      width: 1.6rem;
      height: 1.6rem;
      background: $cWhite;
      border-radius: 50%;
      transition: transform $tr;
    }
  }
}
</style>
